import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import {MatDrawerMode, MatSidenav} from '@angular/material/sidenav';
import {Observable} from 'rxjs';
import {first, map} from 'rxjs/operators';
import {BreakpointService} from '../../core/material/breakpoint.service';
import User, {Role} from '../../core/auth/user';
import {Router} from '@angular/router';
import {AuthService} from '../../core/auth/auth.service';
import {ThemeService} from '../../core/theme/theme.service';
import {Clipboard} from '@angular/cdk/clipboard';
import {environment} from '../../../environments/environment';


@Component({
    selector: 'zah-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: false
})
export class SidenavComponent implements OnInit {
  private breakpointService = inject(BreakpointService);
  private clipboard = inject(Clipboard);
  private authService = inject(AuthService);
  private themeService = inject(ThemeService);
  private router = inject(Router);

  @Input()
  user: User;
  @ViewChild(MatSidenav)
  private matSidenav: MatSidenav;
  sidenavConfig$: Observable<SidenavConfig>;
  logo: string;
  Role = Role;

  ngOnInit(): void {
    this.sidenavConfig$ = this.breakpointService
      .isSmallDevice$()
      .pipe(map(isSmall => isSmall ? SidenavConfig.forSmallDevice() : SidenavConfig.forLargeDevice()));
    this.logo = this.themeService.getLogo();
  }

  open(): void {
    this.matSidenav.open();
  }

  close(): void {
    this.matSidenav.close();
  }

  toggle(): void {
    this.matSidenav.toggle();
  }

  navigateTo(url: string, sidenavConfig: SidenavConfig): void {
    this.router.navigateByUrl(url);
    if (sidenavConfig.isModal()) {
      this.close();
    }
  }

  isUrlActive(url: string): boolean {
    return this.router.isActive(url, false);
  }

  logout(): void {
    this.authService.logout();
  }

  copyTokenToClipBoard(): void {
    if (environment.copyTokenEnabled) {
      this.authService.getToken$()
        .pipe(first())
        .subscribe(token => this.clipboard.copy(token));
    }
  }
}

class SidenavConfig {

  static forSmallDevice(): SidenavConfig {
    return new SidenavConfig('over', false);
  }

  static forLargeDevice(): SidenavConfig {
    return new SidenavConfig('side', true);
  }

  constructor(public mode: MatDrawerMode, public opened: boolean) {
  }

  isModal(): boolean {
    return ['over', 'push'].includes(this.mode);
  }
}
